import { Injectable, OnDestroy, Signal} from "@angular/core";
import { LanguageService, languages_state_interface } from "../../public-api";
import { CookieService } from "ngx-cookie-service";
import { Subscription } from "rxjs";

// Create a signal
@Injectable()

export class BaseService implements OnDestroy
{

lang = 'ar'
userID:number = 0
 public subscriptions: Subscription[] = [];

constructor(public language_s:LanguageService
  ){
    this.subscriptions?.push(this.language_s.get_site_languages_code().subscribe(
  (response : any)=>{
    if(response != null){
    this.lang = response
    }
  }))

//user

}

ngOnDestroy(): void {
  if(this.subscriptions) {
  this.subscriptions?.forEach((subscription) => {
    if(subscription){
    subscription.unsubscribe();
    }
  });
  }
}

}
